var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21935 0.854492L9.71832 1.34127L4.31874 8.74554L0.600098 5.08807L1.43043 4.27803L4.31874 6.04792L9.21935 0.854492Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTick);
export default __webpack_public_path__ + "static/media/single_tick.1a14bc8b.svg";
export { ForwardRef as ReactComponent };